export const sanitizeEnvValue = (value?: string | null) =>
  String(value || '')
    .trim()
    .replace(/^['"]+|['"]+$/g, '');

function decodeJwtPayload(token: string) {
  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  try {
    const normalized = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    return JSON.parse(Buffer.from(padded, 'base64').toString('utf8')) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function getSupabaseProjectRefFromUrl(url?: string | null) {
  const sanitizedUrl = sanitizeEnvValue(url);
  if (!sanitizedUrl) {
    return null;
  }

  try {
    return new URL(sanitizedUrl).hostname.split('.')[0] || null;
  } catch {
    return null;
  }
}

export function getSupabaseProjectRefFromJwt(token?: string | null) {
  const sanitizedToken = sanitizeEnvValue(token);
  if (!sanitizedToken) {
    return null;
  }

  const payload = decodeJwtPayload(sanitizedToken);
  const ref = payload?.ref;
  return typeof ref === 'string' && ref.trim() ? ref.trim() : null;
}